<template>

    <div>
        <div class="container">
            <div class="form-wrap clearfix" style="margin: 15px 0;">
                <form class="search-wrapper pull-left form-inline">
                    <div class="form-group">
                        <label>Search title:</label>
                        <input class="form-control" type="text" v-model="search" placeholder="Search title.."/>
                    </div>
                </form>

                <div class="search-wrapper form-inline pull-right">
                    <select @change="getTreeData($event)" v-model="categorySelected" id="catTree" class="form-control"
                            style="max-width: 400px;">
                        <option v-for="option in categoryTree" v-bind:value="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                    <button @click="getData()" class="btn btn-danger">Clear</button>
                </div>

                <div class="select-product">
                    <div class="row" v-if="checkedItems.length > 0">
                        <div class="col-sm-3">

                            <div class="product-form">
                                <div class="form-group">
                                    <label> {{this.checkedItems.length}} Items Selected (Bulk Actions)</label>
                                    <select class="form-control" v-model="actionSelected" @change="updateActions()">
                                        <option v-for="action in actions" :value="action">
                                            {{action}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="product-form">
                                <div class="form-group">
                                    <label style="display: inline-block;height: 40px;"></label>
                                    <button class="btn btn-danger" @click="clearActions()">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb" style="height:auto;">
                        <li v-for="breadcrumb in breadcrumbs" class="breadcrumb-item"><a href="javascript:void(0)"
                                                                                         @click="getBreadcrumbData(breadcrumb.id)">{{breadcrumb.name}}</a>
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="">
                <div v-if="filteredList.length==0">
                    No record found
                </div>
                <div v-else class="position-relative">
                    <div class="content-loader" v-if="loader">
                        <i class="fas fa-spinner fa-pulse fa-3x" aria-hidden="true"></i>
                    </div>

                    <table class="table table-bordered table-hover table-align-center" style="background-color: #fff;">
                        <thead>
                        <tr>
                            <th scope="col"><input type="checkbox" v-model="checkedAll" @click="checkAll"></th>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Category Path</th>
                            <th scope="col">Image</th>
                            <th scope="col">Published</th>
                            <th scope="col">Actions</th>

                        </tr>
                        </thead>
                        <draggable v-model="list" tag="tbody" @end="onEnd">
                            <tr v-for="item in filteredList">
                                <td scope="row"><input type="checkbox" v-model="checkedItems" :value="item.id"></td>
                                <td scope="row">{{ item.id }}</td>

                                <td><a href="javascript:void(0)" v-on:click="getChildren(item.id)">
                                    {{ item.name }}
                                </a>
                                </td>
                                <td>{{item.path}}</td>
                                <td><img v-if="item.image" :src="item.image" style="width:50px;"></td>
                                <td><span v-if="item.published==1">Yes</span><span v-else>No</span></td>
                                <td>
                                    <div class="btn-group">
                                        <a class="btn btn-xs btn-default dropdown-toggle fa fa-caret-down"
                                           data-toggle="dropdown" href="javascript:void(0)"></a>
                                        <ul class="dropdown-menu dropdown-menu-right">

                                            <li>
                                                <a
                                                        :href="adminUrl+'/catalog/categories/'+item.id+'/edit'"
                                                        target="_blank"><i
                                                        class="fa fa-edit" aria-hidden="true"></i> Edit
                                                </a>
                                            </li>

                                            <li>
                                                <a href="javascript:void(0)" v-on:click="unPublished(item.id)"><i
                                                        class="fa fa-ban" aria-hidden="true"></i>
                                                    <span
                                                            v-if="item.published==1">
                                                Unpublished
                                            </span>
                                                    <span v-else>
                                                Published
                                            </span>
                                                </a>
                                            </li>


                                            <li>
                                                <a href="javascript:void(0)" v-on:click="deleteItem(item.id)"><i
                                                        class="fa fa-trash"></i>
                                                    Delete
                                                </a>
                                            </li>
                                            <!-- <li><button type="button" onclick="pageRedirect()">Print Detail</button></li> -->
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>

                    <!--                            <pagination :data="paginationList" @pagination-change-page="getResults"-->
                    <!--                            ></pagination>-->


                </div>


            </div>


        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import VueSweetalert2 from 'vue-sweetalert2';
    import draggable from 'vuedraggable'
    import Vue from 'vue';
    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';

    Vue.use(VueSweetalert2);

    Vue.component('pagination', require('laravel-vue-pagination'));

    Vue.config.devtools = true;


    Vue.use(VueToast);

    export default {

        components: {draggable},

        data: function () {
            return {
                list: [],
                paginationList: [],
                search: [],
                categorySelected: [],
                categoryTree: [],
                breadcrumbs: [],
                checkedAll: null,
                checkedItems: [],
                actionSelected: '',
                actions: ['', 'Publish', 'Unpublish', 'Delete'],
                loader: null,
            }
        },

        methods: {
            getData() {
                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/categories')
                    .then(function (response) {

                        that.list = response.data.categories;
                        that.paginationList = response.data.categories;
                        that.breadcrumbs = response.data.breadcrumbs;
                        that.categorySelected = null;
                        that.loader = null;

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getTree() {
                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/get-tree')
                    .then(function (response) {
                        that.categoryTree = response.data;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            deleteItem(id) {

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                        let that = this;
                        axios.delete(this.adminApiUrl+'/category/'+id)
                            .then(function (response) {

                                that.list = response.data.categories;

                                console.log("list after delete");
                                console.log(that.list);

                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })

                            })
                            .catch(function (error) {
                                this.$swal('Cancelled', 'Some error found', 'info')
                                console.log(error);
                            })
                            .then(function () {
                            });
                    } else {

                    }
                })


            },

            unPublished(id) {

                let t = this;

                axios.post(this.adminApiUrl+'/category-unpublished', {
                    id: id,
                })
                    .then(function (response) {
                        t.list = response.data.categories;
                        Vue.$toast.open({
                            message: response.data.message,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })


                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },
            positionReset(newIndex, oldIndex, data) {

                let that = this;
                axios.post(this.adminApiUrl+'/categories-position-reset', {
                    newIndex: newIndex,
                    oldIndex: oldIndex,
                    data: data,
                })
                    .then(function (response) {
                        Vue.$toast.open({
                            message: response.data,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            getResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                that.loader = true;

                axios.get(this.adminApiUrl+'/categories?page='+page)
                    .then(function (response) {
                        that.list = response.data.categories.data;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },

            getChildren(id) {

                this.$emit('clicked-show-detail', id);

                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/category-children/'+id)
                    .then(function (response) {
                        that.list = response.data.categories;
                        that.breadcrumbs = response.data.breadcrumbs;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                        Vue.$toast.open({
                            message: error.response.data,
                            type: "warning",
                            duration: 5000,
                            dismissible: true
                        })
                    })
                    .then(function () {
                    });

            },
            getBreadcrumbData(id) {
                this.$emit('clicked-show-detail', id);

                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/breadcrumb/'+id)
                    .then(function (response) {
                        that.list = response.data.categories;
                        that.breadcrumbs = response.data.breadcrumbs;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                        Vue.$toast.open({
                            message: error.response.data,
                            type: "warning",
                            duration: 5000,
                            dismissible: true
                        })
                    })
                    .then(function () {
                    });

            },


            getTreeData(event) {
                console.log(event);
                let id = (event.target.value);
                this.$emit('clicked-show-detail', id);
                console.log(id);
                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/category-tree-data/'+id)
                    .then(function (response) {
                        console.log("tree list");
                        console.log(response.data.categories);
                        that.list = response.data.categories;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                        Vue.$toast.open({
                            message: error.response.data,
                            type: "warning",
                            duration: 5000,
                            dismissible: true
                        })
                    })
                    .then(function () {
                    });

            },
            checkAll() {

                if (this.checkedAll == true) {
                    this.checkedItems = [];
                } else {
                    var selected = [];
                    this.list.forEach(function (product) {
                        selected.push(product.id);
                    });
                    this.checkedItems = selected;
                }

            },
            updateActions() {
                console.log(this.actionSelected);
                if (this.actionSelected == "Delete") {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Delete it!',
                        cancelButtonText: 'No, Keep it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            let that = this;
                            axios.post(this.adminApiUrl+'/category/bulk/delete', {
                                checkedItems: that.checkedItems,
                            })
                                .then(function (response) {

                                    Vue.$toast.open({
                                        message: response.data,
                                        type: "success",
                                        duration: 5000,
                                        dismissible: true
                                    })


                                    that.clearActions();

                                })
                                .catch(function (error) {
                                    that.$swal('Cancelled', 'Some error found', 'info')
                                    console.log(error);
                                })
                        }
                    });


                } else if (this.actionSelected == "Publish") {
                    let that = this;
                    axios.post(this.adminApiUrl+'/category/bulk/publish', {
                        checkedItems: that.checkedItems,
                    })
                        .then(function (response) {

                            Vue.$toast.open({
                                message: response.data,
                                type: "success",
                                duration: 5000,
                                dismissible: true
                            })


                            that.clearActions();


                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else if (this.actionSelected == "Unpublish") {
                    let that = this;
                    axios.post(this.adminApiUrl+'/category/bulk/unpublish', {
                        checkedItems: that.checkedItems,
                    })
                        .then(function (response) {

                            Vue.$toast.open({
                                message: response.data,
                                type: "success",
                                duration: 5000,
                                dismissible: true
                            })


                            that.clearActions();

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },
            clearActions() {
                this.checkedAll = false;
                this.checkedItems = [];
                this.actionSelected = '';
                this.getData();
            },


            onEnd(e) {


                this.positionReset(e.newIndex, e.oldIndex, this.list)

            }

        },
        mounted: function () {
            this.getData();
            this.getTree();

        },
        watch: {
            list: function (newValue, oldValue) {
            },
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            filteredList() {
                let self = this;
                let data;
                console.log("filtered list");
                console.log(self.list);

                data = self.list.filter(l => {
                    return l.name.toLowerCase().includes(self.search)
                })

                return data;

            },
            adminUrl: function () {
                return process.env.MIX_ADMIN_URL;
            },
            adminApiUrl: function () {
                return process.env.MIX_ADMIN_API_URL;
            }

        }
    }

</script>
